import './styles/toggle.css';

// Un interruptor: enciende un modo, no marca una opción.
//
// WHY IT IS NOT A CHECKBOX. A checkbox says «this is one of the things I am
// choosing» — it belongs in a list of peers, and its state is read by looking
// for a tick. A switch says «this mode is on», reads as on or off from across
// the screen, and is the right shape for something that changes HOW the page is
// drawn rather than WHAT it shows.
//
// It is still an `<input type="checkbox">` underneath, and deliberately so: it
// arrives with the label association, the focus, the Space key and the
// announcement already correct. A `<div role="switch">` would mean rebuilding
// all four by hand, and three of them would be subtly wrong.
//
// The input is not `display: none` either — hiding it that way takes it out of
// the tab order. It sits under the track with opacity 0, so focus lands on it
// and the track draws the focus ring.

export default function Toggle({ checked, onChange, label, hint, disabled }) {
    return (
        <label className={`toggle ${disabled ? 'toggle--disabled' : ''}`}>
            <input
                type="checkbox"
                className="toggle__input"
                checked={checked}
                onChange={e => onChange(e.target.checked)}
                disabled={disabled}
                /* `switch` and not the default checkbox role: a screen reader
                   then says «on/off» instead of «checked/unchecked», which is
                   what this control actually means. */
                role="switch"
                aria-checked={checked}
            />

            <span className="toggle__track" aria-hidden="true">
                <span className="toggle__thumb" />
            </span>

            <span className="toggle__text">
                <span className="toggle__label">{label}</span>
                {hint && <span className="toggle__hint">{hint}</span>}
            </span>
        </label>
    );
}
